export enum COGNITO_CHALLENGE_NAME {
  newPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  smsMFA = 'SMS_MFA',
  softwareTokenMFA = 'SOFTWARE_TOKEN_MFA',
}

export const PASSWORD_EXPIRY_LAST_DAYS = 7;
